import request from '../axiosInstance.js'
import loginAPI from './loginAPI.js'

export function login(data) {
  return request({
    url: loginAPI.POST_login,
    method: 'post',
    data: data,
    headers: {
      'Authorization': 'Basic ZHFpLWFkbWluOmRxaTY2ODg=' // 客户端信息加密摘要认证，明文：youlai-admin:123456
    }
  })
}

export function getInfo() {
  return request({
    url: loginAPI.GET_users,
    method: 'get'
  })
}

export function logout() {
  return request({
    url: loginAPI.DELETE_logout,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/http/apiModules/user.js